
export default [{
    path: '/goodsDetail',
    component: ()=> import("@/views/GoodsDetail"),
    meta:{
        title:"植物药详情"
    },
    children:[]
},
{
    path: '/NcpgoodsDetail',
    component: ()=> import("@/views/NcpGoodsDetail"),
    meta:{
        title:"农产品详情"
    },
    children:[]
},
{
    path: '/prescription',
    component: ()=> import("@/views/Prescription"),
    meta:{
        title:"经典药方"
    },
    children:[]
},
{
    path: '/extract',
    component: ()=> import("@/views/Extract"),
    meta:{
        title:"植物提取物"
    },
    children:[]
},

{
    path: '/ncpgoodsDetail',
    component: ()=> import("@/views/NcpGoodsDetail"),
    meta:{
        title:"农产品"
    },
    children:[]
},

{
    path: '/car',
    component: ()=> import("@/views/Car"),
    meta:{
        title:"我的购物车"
    },
    children:[]
},

{
    path: '/goodsList',
    component: ()=> import("@/views/GoodsList"),
    meta:{
        title:"商品列表"
    },
    children:[]
},

{
    path: '/prescriptionDetail',
    component: ()=> import("@/views/PrescriptionDetail"),
    meta:{
        title:"经典药方"
    },
    children:[]
},
{
    path: '/pay',
    component: ()=> import("@/views/Pay"),
    meta:{
        title:"支付"
    },
    children:[]
},
{
    path: '/paysuccess',
    component: ()=> import("@/views/PaySuccess"),
    meta:{
        title:"支付成功"
    },
    children:[]
},
]